module.exports = __webpack_public_path__ + "static/media/startThread.db6f5c2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/startThread.svg
// module id = 1419
// module chunks = 1